import CheckCircle from '@mui/icons-material/CheckCircle';
import EmoticonExcited from '@mui/icons-material/EmojiEmotions';
import * as React from 'react'

export default { CheckCircle, EmoticonExcited, React }